export const Logo = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="tradesite-logo">
    <defs>
      <linearGradient id="gold-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F3E5AB" />
        <stop offset="50%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#AA7C11" />
      </linearGradient>
    </defs>
    <circle cx="50" cy="50" r="44" stroke="url(#gold-grad)" strokeWidth="2" />
    <circle cx="50" cy="50" r="34" stroke="url(#gold-grad)" strokeDasharray="4 4" strokeWidth="1" opacity="0.6" />
    <path
      d="M30 30 H70 V40 H56 V72 H44 V40 H30 Z"
      fill="url(#gold-grad)"
    />
  </svg>
);

export const Wordmark = () => (
  <div className="flex flex-col leading-none">
    <span className="font-serif text-lg tracking-[0.18em] text-[#F8F6F0]">TRADESITE</span>
    <span className="font-mono text-[9px] tracking-[0.52em] text-gold/80">PRO</span>
  </div>
);
